import React from 'react';
import './App.css';
import AppNavbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Vision from './components/Vision';
import Gallery from './components/Gallery';
import Donate from './components/Donate';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <AppNavbar />
      <main>
        <Home />
        <About />
        <Vision />
        <Gallery />
        <Donate />
      </main>
      <Footer />
    </div>
  );
}

export default App;